module.exports = __webpack_public_path__ + "img/carrousel-mamo-2.9c963d57.jpg";